import { useRef } from 'react';
import { useReceiptComposerHost } from '@/stores/receiptComposerHost';
import { ReceiptComposer } from './ReceiptComposer';

// Story 65.19 — ponto único onde o "Receber em partes" é desenhado. Parado, não renderiza
// nada. Aberto, não depende de quem pediu: o detalhe do agendamento pode fechar por trás.
export function ReceiptComposerHost() {
  const request = useReceiptComposerHost((state) => state.request);
  const confirmed = useRef(false);
  if (!request) return null;
  return (
    <ReceiptComposer
      open
      transactionIds={request.ids}
      onDone={() => {
        confirmed.current = true;
      }}
      onClose={() => {
        const outcome = confirmed.current ? 'confirmed' : 'dismissed';
        confirmed.current = false;
        useReceiptComposerHost.getState().close();
        request.onFinished?.(outcome);
      }}
    />
  );
}
